var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot
import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import store from "./reduxStore/store";
import "./css/index.css";
import App from "./App";
// Use createRoot API for React 18
var container = document.getElementById("css-backoffice");
var root = createRoot(container); // Create a root.
var theme = createTheme({
    typography: {
        fontFamily: "'Inter', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "'Inter', sans-serif",
                },
            },
        },
    },
});
root.render(_jsx(React.StrictMode, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(App, {}) })) })) }));
